import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		display: "flex",
		flexWrap: "wrap",
		gap: theme.spacing(1),
		justifyContent: "flex-end",
		marginLeft: "auto",
		padding: theme.spacing(0.75, 1),
	},
}));

const MainHeaderButtonsWrapper = ({ children }) => {
	const classes = useStyles();
	const theme = useTheme();
	const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
	const [toolbarTarget, setToolbarTarget] = useState(null);

	useEffect(() => {
		setToolbarTarget(document.getElementById("page-toolbar-actions"));
	}, []);

	const content = <div className={classes.MainHeaderButtonsWrapper}>{children}</div>;

	return isDesktop && toolbarTarget ? ReactDOM.createPortal(content, toolbarTarget) : content;
};

export default MainHeaderButtonsWrapper;
